type Props = {
  /** Label such as "v1", "v1.1", "v2". When empty, renders nothing. */
  label: string;
};

/** The blue-outlined version pill shown on Workflows cards next to the title. */
export function VersionChip({ label }: Props) {
  if (!label) return null;
  return (
    <span
      style={{
        flexShrink: 0,
        border: '1px solid #0075be',
        color: '#0075be',
        background: '#eef6fb',
        borderRadius: 12,
        fontSize: 12,
        fontWeight: 600,
        padding: '1px 9px',
        lineHeight: '18px',
      }}
    >
      {label}
    </span>
  );
}
